import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const FarmerView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(231)); 
        console.log(permission);

   
      axios
      .get(`/farmers/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.farmer);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(value);

  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Main Farms View</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/farms">
                      Main Farms
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Main Farms
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                    {permission && permission.list === 1 && (
                      <div className="card-body">
                        <h4 className="card-title">Main Farms Details</h4>
                        <table className="table table-bordered">
                          <tr>
                            <th className="p-3">Name</th>
                            <td className="p-3">
                              {value.name}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">GPS Location</th>
                            <td className="p-3">
                              {value.location}
                            </td>
                          </tr>
                      
                          <tr>
                            <th className="p-3">GGN Number</th>
                            <td className="p-3">
                              {value.ggn_number}
                            </td>
                          </tr>
                        
                          <tr>
                            <th className="p-3">Farm Size</th>
                            <td className="p-3">
                              {value.farm_size} (Hectares)
                            </td>
                          </tr>
                        
                          <tr>
                            <th className="p-3">Estimated Crops</th>
                            <td className="p-3">
                              {value.estimated_crops} (Tonnes)
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Farm Codification</th>
                            <td className="p-3">
                              {value.farm_codification} 
                            </td>
                          </tr>
                      
                        
                        
                        </table>
                        <br />
                        <h5 className="card-title">Farm Certificates</h5>

                        <table className="table table-bordered">
                          <tr>
                            <th className="p-3">File Name</th>
                            <th className="p-3">File Type</th>
                            <th className="p-3">File Link</th>
                            <th className="p-3">File Extension</th>
                            <th className="p-3">Expire Date</th>
                            <th className="p-3">Note</th>
                          </tr>
                          {value.allfiles &&
                            value.allfiles.map((item, index) => (
                              <tr   key={item.file_name || index}>
                                <td className="p-3">{item.file_name}</td>
                                <td className="p-3">{item.file_type_name}</td>
                                <td className="p-3">
                                {item.link && (
                                      <a
                                        className="btn btn-primary"
                                        href={viewFile(item.link)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                      >
                                        Download
                                      </a>
                                    )}
                                  
                                </td>
                                <td className="p-3">{item.extension}</td>
                                <td className="p-3">{item.expiry_date}</td>
                                <td className="p-3">{item.note}</td>
                              </tr>
                            ))}
                        </table>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FarmerView;
